//スムーススクロール
$(function(){
	$('a[href^="#"]').click(function(e){
		e.preventDefault();
		var speed = 500;
		var href = $(this).attr("href");
		var wrapper = $('#wrapper');
		var position = 0;
		
		// #slideや空のhrefの場合は一番上へ
		if (href == "#" || href == "" || href == "#slide") {
			position = 0;
		} else {
			// ターゲット要素の位置を取得
			var targetElement = $(href);
			if (targetElement.length) {
				// wrapper内でのターゲット要素の位置を計算
				position = targetElement.offset().top - wrapper.offset().top + wrapper.scrollTop();
			}
		}
		
		// wrapperをスクロール
		wrapper.animate({scrollTop: position}, speed, "swing");
		return false;
	});
});

// バニラJavaScriptでのスムーススクロール（フォールバック）
document.addEventListener('DOMContentLoaded', function() {
	// jQueryが読み込まれていない場合のフォールバック
	if (typeof jQuery === 'undefined') {
		const links = document.querySelectorAll('a[href^="#"]');
		links.forEach(link => {
			link.addEventListener('click', function(e) {
				e.preventDefault();
				const href = this.getAttribute('href');
				const wrapper = document.getElementById('wrapper');
				
				if (wrapper) {
					let targetPosition = 0;
					
					if (href === '#' || href === '' || href === '#slide') {
						targetPosition = 0;
					} else {
						const target = document.querySelector(href);
						if (target) {
							targetPosition = target.offsetTop;
						}
					}
					
					// CSS scroll-behavior: smooth が設定されているので、scrollToを使用
					wrapper.scrollTo({ 
						top: targetPosition, 
						behavior: 'smooth' 
					});
				}
			});
		});
	}
});


//カーソル変更
if(!navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/)){
    $(function(){
        var body = document.body;
        var cursor = document.createElement("div");
        var stalker = document.createElement("div");
        cursor.id = "cursor";
        stalker.id = "stalker";
        body.appendChild(cursor);
        body.appendChild(stalker);
        body.addEventListener("mousemove", function(e) {
              cursor.style.left = e.clientX + "px";
              cursor.style.top = e.clientY + "px";
              stalker.style.left = e.clientX + "px";
              stalker.style.top = e.clientY + "px";
        }, false);
 
        $("a").on("mouseenter", function() {
            $('#cursor').addClass("active");
            $('#stalker').addClass("active");
        });
 
        $("a").on("mouseleave", function() {
            $('#cursor').removeClass("active");
            $('#stalker').removeClass("active");
        });
    });
}

$('.main_slide').slick({
	autoplay: true, //自動再生
	infinite: true, //スライドのループ有効化
	draggable: false,
	arrows: false,
	autoplaySpeed: 2500,
	speed: 2500,
	fade: true,
});